import { gql } from '@apollo/client';

export const RAW_MATERIAL_FRAGMENT = gql`
  fragment rawMaterialValues on AdminRawMaterial {
    id
    title {
      language
      value
    }
    hsCodes {
      id
      code
      description
    }
    logs {
      id
      rawMaterialId
      userId
      action
      createdTimestamp
    }
    latestLog {
      id
      rawMaterialId
      userId
      action
      createdTimestamp
    }
    latestLogAction
  }
`;
